import React from "react";
import { DailyLocomotiveReports } from "../Reports/ReVAMP/DailyLocomotiveInspection/DailyLocomotiveReport";
import { languageService } from "../../Language/language.service";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { printer } from "react-icons-kit/icomoon/printer";
import SvgIcon from "react-icons-kit";
import PathDailyInspectionReport from "../Reports/ReVAMP/PATH/DailyInspectionReport";
const RenderShowReport = ({ props, handleBackClick }) => {
  let { test, assetInfo } = props;
  let { assetName, assetId } = assetInfo;
  let pathDailyReport = test && test.some((test) => test.testCode === "Path_DailyInspection");
  return (
    <div className="mainContent" style={{ textAlign: "center" }}>
      <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
        <div
          className="report-arrow"
          style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
          onClick={(e) => {
            handleBackClick();
          }}
        >
          <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
            {languageService("Reports Menu")}
          </span>
          <SvgIcon icon={arrowLeft} size={24} />
        </div>

        <div
          className="report-print"
          style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
          onClick={(e) => {
            document.title = "Daily Inspection Report";
            window.print();
          }}
        >
          <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
            {languageService("Print Report")}
          </span>
          <SvgIcon icon={printer} size={24} />
        </div>
      </div>
      {pathDailyReport ? (
        <PathDailyInspectionReport reportData={test} selectedAsset={assetName} selectedAssetId={assetId} />
      ) : (
        <DailyLocomotiveReports reportData={test} selectedAsset={assetName} selectedAssetId={assetId} usecustomHeader={true} />
      )}
    </div>
  );
};
export default RenderShowReport;



// WEBPACK FOOTER //
// ./src/components/ReVAMPDailyInpectionReports/RenderShowReport.jsx